@use "../../variables" as *;

.image-wrapper {
  background-color: $white-bis;
  display: flex;
  justify-content: center;
  align-items: center;

  > img,
  > video {
    display: inline-block;
    width: 100%;
    -webkit-transition: opacity 500ms;
    -moz-transition: opacity 500ms;
    -o-transition: opacity 500ms;
    transition: opacity 500ms;
    opacity: 1;
    object-fit: contain;
    aspect-ratio: 2/3;

    @media screen and (orientation: landscape) and (max-device-height: 480px) {
      height: 77vh;
    }
  }

  &.loading {
    &.loadingIndicator {
      animation: skeleton-loading 1s linear infinite alternate;

      @keyframes skeleton-loading {
        0% {
          background-color: $white-bis;
        }
        100% {
          background-color: hsl(100, 4%, 84%);
        }
      }
    }
  }

  &.loading > img,
  &.loading > video {
    -webkit-transition: none;
    -moz-transition: none;
    -o-transition: none;
    transition: none;
    opacity: 0;
  }

  &.cutout {
    img {
      transform: scale(0.9);
    }
  }
}
